<template lang="pug">
	.sfc-blue-box
		.sfc-blue-box-content
			.heading.desktop
				| {{ headingDesktop }}
			.heading.mobile
				| {{ headingMobile }}
			.subheading.desktop
				| {{ subheadingDesktop }}
			.subheading.mobile
				| {{ subheadingMobile }}
			sfc-simple-button(v-if="buttonText" :text="buttonText" :white="whiteButton" :blue="blueButton" :orange="orangeButton" @click="emitCallback($event)" :loading="loading")

</template>
<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'

.sfc-blue-box
	width: 100%
	background: blue-primary
	padding: 85px 0 75px
	@media (max-width: 575px)
		padding: 56px 16px
	@media (min-width: 576px) and (max-width: 991px)
		padding: 72px 33px
	.sfc-blue-box-content
		margin: auto
		text-align: center
		.heading
		.subheading
			color: #fff
			&.desktop
				display: block
			&.mobile
				display: none
			@media (max-width: 767px)
				&.desktop
					display: none
				&.mobile
					display: block
		.heading
			font-weight: body-font-light
			font-size: body-font-size-lg-plus
			line-height: body-font-line-heigth-xss
			margin-bottom: 16px
			@media (max-width: 767px)
				font-size: body-font-size-lg
				line-height: body-font-line-height
				margin-bottom: 8px
		.subheading
			font-weight: bold
			font-size: body-font-size-lg-plus-plus
			line-height: normal
			margin-bottom: 24px
			@media (max-width: 767px)
				font-size: body-font-size-lg-plus
		.sfc-simple-button
			width: 200px
			margin: 0 auto
</style>
<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import SfcUtil from "@/lib/sfc-util.js"
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	export default {
		components: {
				SfcSimpleButton
			},
		props: {
			headingDesktop: {
				type: String,
				default: ''
			},
			subheadingDesktop: {
				type: String,
				default: ''
			},
			headingMobile: {
				type: String,
				default: ''
			},
			subheadingMobile: {
				type: String,
				default: ''
			},
			buttonText: {
				type: String,
				default: undefined
			},
			loading:{
				type: Boolean,
				default: false
			},
			whiteButton:{
				type: Boolean,
				default: false
			},
			blueButton:{
				type: Boolean,
				default: false
			},
			orangeButton:{
				type: Boolean,
				default: false
			}
		},
		methods: {
			emitCallback(event){
				this.$emit('callback', event)
			}
		}
	}
</script>
